import {LocaleGroupType, LocaleType} from "../enums/MemberEnum";

class CommonUtil {
    getUrlPath = () => {
        return window.location.pathname;
    }

    getUrlParam = (paramName) => {
        const urlParams = new URLSearchParams(window.location.search);

        return urlParams.get(paramName);
    }

    getLocaleList = () => {
        const localeList = [];
        for (const local in LocaleType) {
            localeList.push(local);
        }

        return localeList;
    }

    getGroupTypeList = () => {
        const groupTypeList = [];
        for (const type in LocaleGroupType) {
            groupTypeList.push(type);
        }

        return groupTypeList;
    }
}

export const COMMON_UTIL = new CommonUtil();
